import * as actions from "./AlertActions";
import { AlertState, initialAlertState } from "./AlertState";
import * as M from "../../models";
import buildReducer from "../../utils/ReducerBuilder";

export const AlertReducer = buildReducer<AlertState>(initialAlertState)
    .handle(actions.onNewAlert, (state, action) => {
        if (action.payload === undefined)
            return state;

        const alert: M.Alert.Alert = {
            id: state.alerts.size + 1,
            date: new Date().valueOf(),
            dismissed: false,
            message: action.payload.message,
            title: action.payload.title,
            type: action.payload.type,
        };

        return {
            ...state,
            alerts: state.alerts.push(alert),
        };
    })
    .handle(actions.onDismissed, (state, action) => {
        const idx = state.alerts.findIndex((x) => x !== undefined && x.id === action.payload!);
        let alert: M.Alert.Alert | undefined;
        if (idx > -1)
            alert = state.alerts.get(idx);

        if (alert) {
            alert = Object.assign({}, alert);
            alert.dismissed = true;
        }

        console.log(action.payload, alert);

        console.log((alert
            ? state.alerts.set(idx, alert)
            : state.alerts).toArray());

        return {
            ...state,
            alerts: alert
                ? state.alerts.set(idx, alert)
                : state.alerts,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/store/alert/AlertReducer.ts